import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import { Modal } from 'react-bootstrap';

/**
 * @parent NoPermissionIcon
 */
export default class NoPermissionModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    onPermissionGiven: PropTypes.func.isRequired,

    permission: PropTypes.func
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show;
  }

  //
  // events - modal
  //

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  //
  // Renderers
  //

  renderBody() {
    return (
      <div className="row no_permission_modal text-center">
        <h3>
          {I18n.tr('components.no_permission.label')}
        </h3>

      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.no_permission.permission_required')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
